import { Box } from '@wix/design-system';
import React from 'react';
import { CompletedTask } from '../../rule-layout/completed-task/completed-task';
export const InputFixerCompletedState = _ref => {
  var _ruleResult$fixerProp;
  let {
    ruleResult,
    description,
    onEditClick,
    dataHook,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    width: "100%"
  }, /*#__PURE__*/React.createElement(CompletedTask, {
    children: children,
    completedValue: ruleResult.fixerProps.completedRuleContent.value,
    dataHook: dataHook,
    description: description,
    editButtonLabel: ruleResult.fixerProps.completedRuleContent.editButtonLabel,
    inputLabel: ruleResult.fixerProps.completedRuleContent.inputTitle,
    isEditable: ruleResult.isEditableOnceCompleted,
    title: ruleResult.fixerProps.completedRuleContent.title,
    width: (_ruleResult$fixerProp = ruleResult.fixerProps.design) == null ? void 0 : _ruleResult$fixerProp.width,
    onClickEdit: () => {
      onEditClick();
    }
  }));
};
//# sourceMappingURL=input-fixer-completed-state.js.map